import VExpenseInvoiceInfoEditor from '../components_v/v-expense-invoice-info-editor.vue'
import { INVOICE_INFO_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: INVOICE_INFO_FIELD,
    mixins: [ commonMixins ],
    computed: {
        inner() {
            return this.$refs.VExpenseInvoiceInfoEditor
        }
    },
    render(h) {
        return h(VExpenseInvoiceInfoEditor, {
            ref: 'VExpenseInvoiceInfoEditor',
            props: {
                field: this.field,
                value: this.my_value
            },
        })
    }
}